import Districts from '../model/user/Districts';
import Schools from '../model/user/Schools';
import Specializations from '../model/user/Specializations';
import Teachers from '../model/user/Teachers';
import axios from 'axios';

export async function getDistricts() {
	const response = await fetch(process.env.REACT_APP_API_URL + '/olympics/districts');
	const data = await response.json();
	return Districts.fromApiResponse(data);
}

export async function getSchools() {
	const response = await fetch(process.env.REACT_APP_API_URL + '/olympics/schools');
	const data = await response.json();
	return Schools.fromApiResponse(data);
}

export async function getSpecializations() {
	const response = await fetch(process.env.REACT_APP_API_URL + '/olympics/specializations');
	const data = await response.json();
	return Specializations.fromApiResponse(data);
}

export async function getTeachersByDistrictId(id: string) {
	const response = await fetch(process.env.REACT_APP_API_URL + `/teachers/filter?districtIds[]=${id}`);
	const data = await response.json();
	return Teachers.fromApiResponse(data);
}

export async function getAllTeachers() {
	const response = await fetch(process.env.REACT_APP_API_URL + '/teachers/filter');
	const data = await response.json();
	return Teachers.fromApiResponse(data);
}

export const getUserData = async (token: string | null) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/students/me' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.get(url, config);
};

export const uploadStudentOpinion = async (token: string, files: File | File[]) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/students/me/opinion' : '';
	const list = Array.isArray(files) ? files : [files];
	const formData = new FormData();
	list.forEach((f) => formData.append('file[]', f));
	return axios.post(url, formData, {
		headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' },
	});
};

/** Pobierz skan opinii (lokalny / Drive przez API) — do podglądu w dialogu. */
export const fetchStudentOpinionBlob = async (token: string, studentId: number, fileId?: number) => {
	const base = process.env.REACT_APP_API_URL ? `${process.env.REACT_APP_API_URL}/students/${studentId}/opinion` : '';
	const url = fileId && fileId > 0 ? `${base}?fileId=${fileId}` : base;
	const response = await axios.get(url, {
		headers: { Authorization: `Bearer ${token}` },
		responseType: 'blob',
	});
	return response.data as Blob;
};

export const getTeacherDeclaredStatus = async (token: string) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/teachers/declared-status' : '';
	return axios.get(url, { headers: { Authorization: `Bearer ${token}` } });
};

export const getStudentOpinionDriveSettings = async (token: string) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/student-opinion-drive' : '';
	return axios.get(url, { headers: { Authorization: `Bearer ${token}` } });
};

export const saveStudentOpinionDriveSettings = async (token: string, folderUrl: string) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/student-opinion-drive' : '';
	return axios.put(url, { folderUrl }, { headers: { Authorization: `Bearer ${token}` } });
};

export type PanelHelpLink = {
	label: string;
	url: string;
	roles: string[];
};

export const getPanelHelpSettings = async (token: string) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/panel-help' : '';
	return axios.get(url, { headers: { Authorization: `Bearer ${token}` } });
};

export const savePanelHelpSettings = async (
	token: string,
	payload: { helpIntro: string; helpLinks: PanelHelpLink[] },
) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/panel-help' : '';
	return axios.put(url, payload, { headers: { Authorization: `Bearer ${token}` } });
};

export const sendCertificateData = async (token: string | null, data: any) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/students/certificate/data' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post(url, data, config);
};
